import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { Row, Col, Form, Input, Button, Select, Spin } from 'antd';

import { useDispatch } from 'react-redux';
import { AuthFormWrap } from './style';
import { verify } from '../../../../redux/authentication/actionCreator';
import { useParams } from 'react-router-dom';

function Verification() {
  const dispatch = useDispatch();
  const [msg, setMsg] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { id, hash } = useParams();
  const initialized = useRef(false);

  const handleVerify = useCallback(() => {
    setIsLoading(true);

    dispatch(
      verify({ id: id, hash: hash }, (data) => {
        setIsLoading(false);
        setMsg(data);
      }),
    );
  }, []);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      handleVerify();
    }
  }, []);

  return (
    <>
      <Row justify="center">
        <Col xxl={6} xl={8} md={12} sm={18} xs={24}>
          <AuthFormWrap className="mt-6 bg-white rounded-md dark:bg-white10 shadow-regular dark:shadow-none">
            <div className="px-5 py-4 text-center border-b border-gray-200 dark:border-white10">
              <h2 className="mb-0 text-xl font-semibold text-dark dark:text-white87">Weryfikacja konta</h2>
            </div>
            {isLoading && (
              <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
                <Spin />
              </div>
            )}
            {msg && (
              <div style={msg?.status === 'error' ? { color: 'red' } : {}} className="px-10 pt-8 pb-6">
                {msg?.message}
              </div>
            )}
            <div className="p-6 text-center bg-gray-100 dark:bg-white10 rounded-b-md">
              <p className="mb-0 text-sm font-medium text-body dark:text-white60">
                <Link to="/" className="ltr:ml-1.5 rtl:mr-1.5 text-info hover:text-primary">
                  Zaloguj się
                </Link>
              </p>
            </div>
          </AuthFormWrap>
        </Col>
      </Row>
    </>
  );
}

export default Verification;
